import React, { useState } from 'react';
import { SERVICE_AREAS_MAP } from '../../mock/cates-content.mock';

const BRAND_BLUE = '#0072c6';
const BRAND_LIGHT = '#1493e6';

// Stylised Northeast Florida coastline. Deliberately schematic — it shows
// coverage at a glance rather than claiming survey accuracy. Coordinates in
// SERVICE_AREAS_MAP are percentages of this panel, not real lat/long.
const ServiceAreaMap: React.FC = () => {
  const [active, setActive] = useState<string | null>(null);

  return (
    <div style={{
      position: 'relative', width: '100%', aspectRatio: '4 / 3',
      minHeight: '320px', borderRadius: '1.25rem', overflow: 'hidden',
      background: 'linear-gradient(160deg, #0b2233 0%, #05131f 100%)',
      border: '1px solid rgba(20,147,230,0.32)',
    }}>
      <svg viewBox="0 0 100 100" preserveAspectRatio="none" style={{ position: 'absolute', inset: 0, width: '100%', height: '100%' }}>
        {/* Atlantic */}
        <rect x="0" y="0" width="100" height="100" fill="#06121d" />
        {/* Landmass */}
        <path
          d="M0,4 L58,4 C62,10 64,16 66,22 C68,28 70,34 71,42 C72,50 70,58 66,66 C62,74 58,84 56,100 L0,100 Z"
          fill="#0f2c3f"
          stroke="rgba(20,147,230,0.4)"
          strokeWidth="0.4"
        />
        {/* St. Johns River */}
        <path
          d="M40,4 C42,14 40,22 38,30 C36,40 34,52 33,64 C32,76 32,88 31,100"
          fill="none"
          stroke="rgba(20,147,230,0.5)"
          strokeWidth="1.1"
          strokeLinecap="round"
        />
        {/* Intracoastal */}
        <path
          d="M69,14 C70,26 69,38 66,50 C63,62 60,74 58,88"
          fill="none"
          stroke="rgba(20,147,230,0.3)"
          strokeWidth="0.7"
        />
      </svg>

      <span style={{
        position: 'absolute', right: '3%', top: '46%',
        color: 'rgba(20,147,230,0.5)', fontSize: '0.62rem', fontWeight: 700,
        letterSpacing: '0.18em', textTransform: 'uppercase',
        writingMode: 'vertical-rl',
      }}>Atlantic Ocean</span>

      {SERVICE_AREAS_MAP.map(area => {
        const isActive = active === area.city;
        const size = area.primary ? 15 : 10;
        return (
          <button
            key={area.city}
            type="button"
            onMouseEnter={() => setActive(area.city)}
            onMouseLeave={() => setActive(null)}
            onFocus={() => setActive(area.city)}
            onBlur={() => setActive(null)}
            aria-label={area.city}
            style={{
              position: 'absolute', left: `${area.x}%`, top: `${area.y}%`,
              transform: 'translate(-50%, -50%)',
              width: `${size}px`, height: `${size}px`, borderRadius: '50%',
              background: area.primary ? BRAND_LIGHT : BRAND_BLUE,
              border: `2px solid ${area.primary ? 'white' : 'rgba(255,255,255,0.75)'}`,
              boxShadow: isActive ? `0 0 0 8px rgba(20,147,230,0.28)` : '0 2px 8px rgba(0,0,0,0.5)',
              cursor: 'pointer', padding: 0, transition: 'box-shadow 0.2s',
            }}
          />
        );
      })}

      {SERVICE_AREAS_MAP.map(area => (
        <span
          key={`${area.city}-label`}
          style={{
            position: 'absolute', left: `${area.x}%`, top: `calc(${area.y}% + ${area.primary ? 15 : 11}px)`,
            transform: 'translateX(-50%)',
            color: active === area.city ? 'white' : 'rgba(230,237,245,0.82)',
            fontSize: area.primary ? '0.76rem' : '0.66rem',
            fontWeight: area.primary ? 800 : 600,
            whiteSpace: 'nowrap', pointerEvents: 'none',
            textShadow: '0 1px 4px rgba(0,0,0,0.9)',
            opacity: active && active !== area.city ? 0.45 : 1,
            transition: 'opacity 0.2s, color 0.2s',
          }}
        >{area.city}</span>
      ))}
    </div>
  );
};

export default ServiceAreaMap;
